import React, { useState } from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import ReactModal from 'react-modal';
import './style/capture-warning.css';

const LABELS = { name: 'Name missing', mobile: 'Mobile number missing' };

export default function CaptureWarning({ media }) {
  const [open, setOpen] = useState(false);
  const missing = [...new Set((media?.missing_capture_fields || []).filter((field) => LABELS[field]))];
  if (!missing.length) return null;
  return <>
    <button type="button" className="gallery-capture-warning" aria-label={`Missing capture details for media ${media.id}`}
      title="Missing capture details" onClick={(event) => { event.preventDefault(); event.stopPropagation(); setOpen(true); }}><FiAlertTriangle aria-hidden="true" /></button>
    <ReactModal isOpen={open} onRequestClose={() => setOpen(false)} contentLabel="Missing capture details"
      className="gallery-capture-warning-dialog" overlayClassName="gallery-capture-warning-overlay">
      <button type="button" className="gallery-capture-warning-close" onClick={() => setOpen(false)} aria-label="Close missing capture details"><FiX /></button>
      <h2><FiAlertTriangle aria-hidden="true" /> Missing capture details</h2>
      <p>{media.capture_match_found === false ? 'No matching data capture was found for this file.' : 'Some capture details linked to this file are missing or could not be matched.'}</p>
      <ul>{missing.map((field) => <li key={field}>{LABELS[field]}</li>)}</ul>
      <button type="button" className="gallery-capture-warning-done" onClick={() => setOpen(false)}>Close</button>
    </ReactModal>
  </>;
}
